import { render, staticRenderFns } from "./ServerTasks.vue?vue&type=template&id=190f6987&scoped=true"
import script from "./ServerTasks.vue?vue&type=script&lang=js"
export * from "./ServerTasks.vue?vue&type=script&lang=js"
import style0 from "./ServerTasks.vue?vue&type=style&index=0&id=190f6987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190f6987",
  null
  
)

export default component.exports